import {
  Theme,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface CustomProps {
  count: number;
  shape: "rounded" | "circular";
  onPageChange: Function;
  onRowsPerPageChange?: Function;
  page: number;
  rowsPerPage: number;
  rowsPerPageOptions: number[];
  showJumpToPageNumber?: boolean;
  jumpToPageNumber?: number;
  setJumpToPageNumber?: Function;
  handleOnChangePageInput?: Function;
}

const CustomPagination = (props: CustomProps) => {
  const theme = useTheme();
  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up("sm"));

  const count = Math.ceil(props.count / props.rowsPerPage);
  const isError =
    props.jumpToPageNumber === undefined ||
    props.jumpToPageNumber === null ||
    props.jumpToPageNumber > count ||
    props.jumpToPageNumber < 1;

  return (
    <Stack
      direction={{
        xs: "column",
        sm: "row",
      }}
      spacing={2}
      m={2}
      alignItems={{
        xs: "flex-start",
        sm: "center",
      }}
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={2} alignItems="center">
        {props.rowsPerPage > 0 && (
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="subtitle2" color="text.primary">Rows per page:</Typography>
            <Select
              size="small"
              value={props.rowsPerPage}
              variant="standard"
              onChange={(event) =>
                props.onRowsPerPageChange!(event.target.value)
              }
            >
              {props.rowsPerPageOptions.map((item: number) => (
                <MenuItem key={item} value={item}>
                  {item}
                </MenuItem>
              ))}
            </Select>
          </Stack>
        )}
      </Stack>
      <Pagination
        page={props.page}
        count={count}
        shape={props.shape}
        siblingCount={1}
        onChange={(event, page: number) => {
          props.onPageChange(event, page);
        }}
        size={smUp ? "medium" : "small"}
        sx={{
          "& .MuiPaginationItem-root": {
            fontSize: "14px",
            fontWeight: "500",
            borderRadius: "3px",
            backgroundColor: "#47556914",
            color: theme.palette.primary.dark,
          },
          // "& .MuiPagination-ul": {
          //   backgroundColor: "#47556914",
          //   borderRadius: "8px",
          // },
          "& .MuiPaginationItem-ellipsis": {
            color: theme.palette.primary.dark,
            backgroundColor: "#FFFFFF",
          },
          "& .MuiPaginationItem-root.Mui-selected": {
            backgroundColor: theme.palette.primary.main,
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: theme.palette.primary.main,
              color: "#FFFFFF",
            },
          },
        }}
      />
    </Stack>
  );
};

export default CustomPagination;
